import React from 'react';
import Button from '../../UI/button';
import { Spinner } from 'react-bootstrap';
import styles from './base-item-card.module.css';
import { ItemAction } from './types';

interface ItemCardActionsProps {
  primaryAction?: ItemAction;
  secondaryActions?: ItemAction[];
  itemId: string;
}

export const ItemCardActions: React.FC<ItemCardActionsProps> = ({
  primaryAction,
  secondaryActions,
  itemId
}) => {
  console.log('[ItemCardActions] RENDERED - itemId:', itemId);

  if (!primaryAction && (!secondaryActions || secondaryActions.length === 0)) {
    return null;
  }

  return (
    <div className={styles.cardActions}>
      {/* Primary Action */}
      {primaryAction && (
        <Button
          variant={primaryAction.variant || 'primary'}
          size='sm'
          onClick={(e) => {
            e.stopPropagation();
            primaryAction.onClick(itemId);
          }}
          disabled={primaryAction.disabled || primaryAction.loading}
          title={primaryAction.tooltip}
          className={styles.primaryAction}
        >
          {primaryAction.loading ? (
            <Spinner
              as='span'
              animation='border'
              size='sm'
              role='status'
              aria-hidden='true'
            />
          ) : (
            <>
              {primaryAction.icon && (
                <span className={styles.actionIcon}>{primaryAction.icon}</span>
              )}
              {primaryAction.label}
            </>
          )}
        </Button>
      )}

      {/* Secondary Actions */}
      {secondaryActions && secondaryActions.length > 0 && (
        <div className={styles.secondaryActions}>
          {secondaryActions.map((action, index) => (
            <Button
              key={index}
              variant={action.variant || 'link'}
              size='sm'
              onClick={(e) => {
                e.stopPropagation();
                action.onClick(itemId);
              }}
              disabled={action.disabled || action.loading}
              title={action.tooltip}
              className={styles.secondaryAction}
            >
              {action.loading ? (
                <Spinner
                  as='span'
                  animation='border'
                  size='sm'
                  role='status'
                  aria-hidden='true'
                />
              ) : (
                <>
                  {action.icon && (
                    <span className={styles.actionIcon}>{action.icon}</span>
                  )}
                  {action.label}
                </>
              )}
            </Button>
          ))}
        </div>
      )}
    </div>
  );
};
